export function showModal(modalId) {
  $('#' + modalId).modal('show');
}

export function hideModal(modalId) {
  $('#' + modalId).modal('hide');
}



// WEBPACK FOOTER //
// ./client/app/shared/ui/modal.util.js